module.exports = {
      id: "v-plus-logo-usage",
      viewBox: "0 0 165.404 72.698",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#v-plus-logo",
      toString: function () {
        return this.url;
      }
    }